import { teamMembers1, teamMembers2, TeamMember } from "../../../constants/ourTeam/teamMembers";
import "./teamCarousel.css";

function CarouselRow({ members, reverse = false }: { members: TeamMember[]; reverse?: boolean }) {
  return (
    <div className="carousel-row">
      <div className={`carousel-track ${reverse ? "carousel-track-reverse" : ""}`}>
        {[...members, ...members].map((member, index) => (
          member.linkedin ? (
            <a
              key={index}
              href={member.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="carousel-item"
              title={member.name}
            >
              <img src={member.image} alt={member.name} />
            </a>
          ) : (
            <div
              key={index}
              className="carousel-item"
              title={member.name}
            >
              <img src={member.image} alt={member.name} />
            </div>
          )
        ))}
      </div>
    </div>
  );
}

export default function TeamCarousel() {
  return (
    <div className="team-carousel-wrapper">
      <CarouselRow members={teamMembers1} />
      <CarouselRow members={teamMembers2} reverse />
      <CarouselRow members={teamMembers1} />
    </div>
  );
}